import api from "@/plugins/api";
export async function searchAdresse(query, limit = 5) {
    const response = await api.get("/organisations/adresse-search", { params: { q: query.trim(), limit } });
    return { results: response.data.data };
}
